/*
 * <sticky-add-to-cart> — toont een vaste 'In winkelwagen'-balk zodra de echte
 * koopknop uit beeld scrolt. Verzendt hetzelfde formulier (via form="..."), dus
 * geen tweede product-form en geen losse cart-POST. Prijs/status syncen via het
 * variantChange-event dat product-info.js publiceert.
 */
if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.targetButton = document.getElementById(this.dataset.target);
        this.stickyPrice = this.querySelector(`#StickyPrice-${this.sectionId}`);
        this.button = this.querySelector('.sticky-atc__button');

        this.syncFromMain();

        if (this.targetButton && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              this.classList.toggle('is-visible', !entries[0].isIntersecting);
            },
            { threshold: 0 }
          );
          this.observer.observe(this.targetButton);
        }

        if (typeof subscribe === 'function') {
          this.variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event?.data?.sectionId && event.data.sectionId !== this.sectionId) return;
            this.syncFromMain();
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.variantUnsub) this.variantUnsub();
      }

      syncFromMain() {
        const mainPrice = document.getElementById(`price-${this.sectionId}`);
        if (mainPrice && this.stickyPrice) this.stickyPrice.innerHTML = mainPrice.innerHTML;

        this.targetButton = this.targetButton || document.getElementById(this.dataset.target);
        if (this.targetButton && this.button) {
          const disabled =
            this.targetButton.hasAttribute('disabled') ||
            this.targetButton.getAttribute('aria-disabled') === 'true';
          this.button.toggleAttribute('disabled', disabled);

          const mainText = this.targetButton.querySelector('span');
          const myText = this.button.querySelector('span');
          if (mainText && myText && mainText.textContent.trim()) myText.textContent = mainText.textContent.trim();
        }
      }
    }
  );
}
